var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Form Control Type / Checkbox"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8487_218542)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.76001,
    y: 0.519043,
    width: 18,
    height: 18,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon",
    x: 1.51001,
    y: 1.26904,
    width: 16.5,
    height: 16.5,
    rx: 3.25,
    fill: "white",
    stroke: "#CDCDCD",
    strokeWidth: 1.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8487_218542"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.76001,
    y: 0.519043,
    width: 18,
    height: 18,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxUnchecked);
export default __webpack_public_path__ + "static/media/checkbox-unchecked.d7fbf064c353cac8e38c98addbe99278.svg";
export { ForwardRef as ReactComponent };